import { useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';

import { createWarehouseStorageConfig } from 'repositories/HttpRepository';
import { defaultStorageAreas, warehouseSetupErrorMessage } from 'utils/warehouseLocationSetup';

export default function useStorageAreaForm({ warehouseId, initialAreas, onSuccess }) {
  const { control, handleSubmit, getValues, watch } = useForm({
    defaultValues: { areas: initialAreas?.length ? initialAreas : defaultStorageAreas() },
  });
  const { fields, append, remove } = useFieldArray({ control, name: 'areas', keyName: 'key' });
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isUniqueAreaName = (value) => {
    const names = getValues('areas').map((area) => (area.name || '').trim());
    return names.filter((name) => name === (value || '').trim()).length <= 1 || 'Storage area names must be unique';
  };

  const addArea = () => append({ name: '', locations: [] });

  const submit = handleSubmit((values) => {
    const storageAreas = values.areas.map((area) => ({ name: area.name.trim(), locations: area.locations }));
    setSubmitting(true);
    setSubmitError('');
    return createWarehouseStorageConfig(warehouseId, { warehouseId, storageAreas })
      .then((res) => {
        if (res.ok) {
          onSuccess();
          return;
        }
        setSubmitError(warehouseSetupErrorMessage(res.data?.id) || 'Failed to create the storage config.');
      })
      .catch(() => {
        setSubmitError('Failed to create the storage config.');
      })
      .finally(() => {
        setSubmitting(false);
      });
  });

  return {
    control,
    fields,
    addArea,
    removeArea: remove,
    isUniqueAreaName,
    watch,
    submit,
    submitError,
    submitting,
  };
}
